var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Header", { attrs: { highlight: _vm.isDirty } }, [
    _c(
      "div",
      { staticClass: "dashboards-maker--header m_b_1" },
      [
        _vm._t("title"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "dashboards-maker--header dashboards-maker--header__buttons"
          },
          [
            _c(
              "Button",
              {
                attrs: { icon: "trash", template: "link" },
                nativeOn: {
                  click: function($event) {
                    return _vm.handleDeleteButton($event)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.deleteLabel) + "\n      ")]
            ),
            _vm._v(" "),
            _vm.showViewItem
              ? _c(
                  "Button",
                  {
                    attrs: { icon: "external-link-alt", template: "link" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.handleSeeItemButton($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.viewItemLabel) + "\n      "
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dashboards-maker--header" },
      [
        _vm._t("checkbox"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dashboards-maker--button" },
          [
            _vm.isDirty
              ? _c("i", [_vm._v(_vm._s(_vm.changesLabel))])
              : _vm._e(),
            _vm._v(" "),
            _vm.isDirty
              ? _c(
                  "Button",
                  {
                    class: { "is-shaking": _vm.shaking },
                    attrs: { template: "link" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.handleCloseButton($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.closeNoSaveLabel) + "\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "Button",
              {
                class: { "is-shaking": _vm.shaking },
                attrs: { disabled: !_vm.isDirty },
                nativeOn: {
                  click: function($event) {
                    return _vm.handleSaveButton($event)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.saveLabel) + "\n      ")]
            )
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }